"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHorLoadingBar = exports.StyledHorLoader = exports.StyledLoaderOverlay = exports.StyledLoaderWrapper = exports.StyledCircLoader = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var colors_1 = require("../../themes/colors");
var utilsOolib_1 = require("../../utilsOolib");
var greyColor10 = colors_1.colors.greyColor10, greyColor70 = colors_1.colors.greyColor70, white = colors_1.colors.white;
var spin = (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n"], ["\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n"])));
exports.StyledCircLoader = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex-shrink: 0;\n  display: inline-block;\n  animation: ", " 1.2s linear infinite;\n  border-radius: 50%;\n  ", "\n"], ["\n  flex-shrink: 0;\n  display: inline-block;\n  animation: ", " 1.2s linear infinite;\n  border-radius: 50%;\n  ", "\n"])), spin, function (_a) {
    var diameter = _a.diameter, trackThickness = _a.trackThickness, invert = _a.invert, theme = _a.theme;
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n    border-style: solid;\n    border-width: ", "px;\n    border-color: ", ";\n    border-top-color: ", ";\n  "], ["\n    width: ", "px;\n    height: ", "px;\n    border-style: solid;\n    border-width: ", "px;\n    border-color: ", ";\n    border-top-color: ", ";\n  "])), diameter, diameter, trackThickness, invert ? greyColor70 : greyColor10, invert ? white : (0, utilsOolib_1.getPrimaryColor100)(theme.colors));
});
exports.StyledLoaderWrapper = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n\n  ", ";\n"])), function (_a) {
    var isBlock = _a.isBlock;
    return isBlock && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-direction: column;\n    justify-content: center;\n    gap: 1.2rem;\n    text-align: center;\n  "], ["\n    flex-direction: column;\n    justify-content: center;\n    gap: 1.2rem;\n    text-align: center;\n  "])));
});
exports.StyledLoaderOverlay = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background-color: transparent;\n  width: 100%;\n  height: ", ";\n  display: grid;\n  place-items: center;\n"], ["\n  background-color: transparent;\n  width: 100%;\n  height: ", ";\n  display: grid;\n  place-items: center;\n"])), function (_a) {
    var blockHeight = _a.blockHeight;
    return blockHeight;
});
exports.StyledHorLoader = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: ", ";\n  height: 1rem;\n  position: relative;\n  border-radius: 1rem;\n  overflow: hidden;\n  border: 1px solid ", ";\n"], ["\n  width: ", ";\n  height: 1rem;\n  position: relative;\n  border-radius: 1rem;\n  overflow: hidden;\n  border: 1px solid ", ";\n"])), function (_a) {
    var barWidth = _a.barWidth;
    return barWidth + 'px';
}, function (_a) {
    var theme = _a.theme;
    return (0, utilsOolib_1.getPrimaryColor100)(theme.colors);
});
exports.StyledHorLoadingBar = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  background-color: ", ";\n  width: ", ";\n"], ["\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  background-color: ", ";\n  width: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return (0, utilsOolib_1.getPrimaryColor100)(theme.colors);
}, function (_a) {
    var progress = _a.progress, barWidth = _a.barWidth;
    return (progress / 100) * barWidth + "px";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
